import BrowseUsersStore from "@/areas/settings/stores/BrowseUsersStore";
import BrowseRolesStore from "@/areas/settings/stores/BrowseRolesStore";
import BrowseRiskTypesStore from "@/areas/settings/stores/BrowseRiskTypesStore";
import CreateRiskTypeStore from "@/areas/settings/stores/CreateRiskTypeStore";
import BrowseNotificationStore from "@/areas/settings/stores/BrowseNotificationStore";
import CreateTrustedDomainStore from "@/areas/directory/stores/CreateTrustedDomainStore";
import BrowseRegistriesStore from "@/areas/settings/stores/BrowseRegistriesStore";
import BrowseAuditRegistriesStore from "@/areas/settings/stores/BrowseAuditRegistriesStore";

import CreateRegistryStore from "@/areas/settings/stores/CreateRegistryStore";
import CreateAuditRegistryStore from "@/areas/settings/stores/CreateAuditRegistryStore";

import ExportUsersStore from "@/areas/settings/stores/ExportUsersStore";

export default class SettingsRootStore {
  constructor(parentStore) {
    this.parentStore = parentStore;

    this.browseUsersStore = new BrowseUsersStore(this);
    this.exportUsersStore = new ExportUsersStore(this);
    this.browseRolesStore = new BrowseRolesStore(this);
    this.browseNotificationStore = new BrowseNotificationStore(this);
    this.browseRiskTypesStore = new BrowseRiskTypesStore(this);
    this.createRiskTypeStore = new CreateRiskTypeStore(this);
    this.createTrustedDomainStore = new CreateTrustedDomainStore(this);
    this.browseRegistriesStore = new BrowseRegistriesStore(this);
    this.browseAuditRegistriesStore = new BrowseAuditRegistriesStore(this);
    this.createRegistryStore = new CreateRegistryStore(this);
    this.createAuditRegistryStore = new CreateAuditRegistryStore(this);
  }
}
